{
  "version": "v4.3.0",
  "name": "TickBitmapTest",
  "bytecode": "02091e4050406c409f410041164131415941680000010101120e16007a7a1241003a7a05294b033a904a023a221302640200000105011b1600000017011601cb17021602c54c02160202b21301640c130164170417031601ce0016031604c11816020200000103010d1600000017011601cb17021602c54c02160202ce000200000103001e1600ce0123052413412d7b16007a7ace013a7a05294b033a904a023a22170116010001170216010d0c160201020000020602403016007a7ace013a7a05294b033a904a023a2216014c02054a01061f170216020002170316021601ce010f0e1603010317051704160412bff27618264c0212bff276181704160412800d89e8284c0212800d89e817041604160502010003030108d37afb14100d1600160116021304640201000405010ad35b19984c1601160216030005170416001604cc02010303060113d3b7624ae716011602130264130064170417031600d1a2b116031604af1705160502010001010003d3a2f62a8d16000003",
  "codeHash": "5cb6cce5c5b8adb88a18a993227d51465e3e54b5a34936cafc51100725724b54",
  "fieldsSig": {
    "names": [
      "wordTemplate",
      "tickSpacing"
    ],
    "types": [
      "ByteVec",
      "I256"
    ],
    "isMutable": [
      false,
      false
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "wordPath",
      "paramNames": [
        "compressed"
      ],
      "paramTypes": [
        "I256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "getWord",
      "paramNames": [
        "compressed"
      ],
      "paramTypes": [
        "I256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "BitmapWord"
      ]
    },
    {
      "name": "getWordOrTemplate",
      "paramNames": [
        "compressed"
      ],
      "paramTypes": [
        "I256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "BitmapWord"
      ]
    },
    {
      "name": "flipTick",
      "paramNames": [
        "tick"
      ],
      "paramTypes": [
        "I256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": []
    },
    {
      "name": "nextInitializedTickWithinOneWord",
      "paramNames": [
        "tick",
        "zeroForOne"
      ],
      "paramTypes": [
        "I256",
        "Bool"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "I256",
        "Bool"
      ]
    },
    {
      "name": "positionPath",
      "paramNames": [
        "o",
        "tickLower",
        "tickUpper"
      ],
      "paramTypes": [
        "Address",
        "I256",
        "I256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "positionContractId",
      "paramNames": [
        "pool",
        "o",
        "tickLower",
        "tickUpper"
      ],
      "paramTypes": [
        "Pool",
        "Address",
        "I256",
        "I256"
      ],
      "paramIsMutable": [
        false,
        false,
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "deploy",
      "paramNames": [
        "payer",
        "word",
        "ts"
      ],
      "paramTypes": [
        "Address",
        "BitmapWord",
        "I256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "TickBitmapTest"
      ]
    },
    {
      "name": "flipTick_",
      "paramNames": [
        "tick"
      ],
      "paramTypes": [
        "I256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": []
    }
  ],
  "constants": [],
  "enums": [
    {
      "name": "TickBitmapError",
      "fields": [
        {
          "name": "TickNotAligned",
          "value": {
            "type": "U256",
            "value": "301"
          }
        }
      ]
    },
    {
      "name": "PathPrefixes",
      "fields": [
        {
          "name": "Tick",
          "value": {
            "type": "U256",
            "value": "0"
          }
        },
        {
          "name": "Position",
          "value": {
            "type": "U256",
            "value": "1"
          }
        },
        {
          "name": "Word",
          "value": {
            "type": "U256",
            "value": "2"
          }
        }
      ]
    }
  ]
}